import { NavigationSlider } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import SectionDivider from 'site/Renderer/components/SectionDivider'
import { AreaLineCenter } from 'site/Renderer/components/DataTables/DataTable.styles'

interface KanbanAreaLineProps {
  currentSection: number
  totalNavigationPages: number
  setCurrentSection: (section: number) => void
  objectclassName?: string
  shouldDisplayNavigation?: boolean
  children?: React.ReactNode
}

const KanbanAreaLine = ({
  currentSection,
  totalNavigationPages,
  setCurrentSection,
  objectclassName,
  shouldDisplayNavigation = false,
  children
}: KanbanAreaLineProps) => {
  const { t } = useTranslation()

  const centerHeaderElement = (
    <AreaLineCenter aria-label='Area line center'>
      {shouldDisplayNavigation && (
        <NavigationSlider
          currentPosition={currentSection + 1}
          first={1}
          total={totalNavigationPages}
          textForCurrent={t('kanban.section')}
          afterClick={(n) => setCurrentSection(n - 1)}
          doubleArrowhead={false}
          hierarchyLevel='level_2'
          heightClass='small'
        />
      )}
    </AreaLineCenter>
  )

  return (
    <>
      <SectionDivider
        title={objectclassName}
        isCollapsibleCard={false}
        centerHeaderElement={centerHeaderElement}
        backgroundColor='#004099'
        hideCollapsibleCardArrow={false}
        isVisible={true}
      >
        {children}
      </SectionDivider>
    </>
  )
}

export default KanbanAreaLine
